var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.211854 0.227618C0.482343 -0.0509656 0.91668 -0.074697 1.21479 0.161211L9.77246 8.45913C9.91793 8.60028 9.99988 8.79454 10 8.99722C10 9.20004 9.918 9.39503 9.77246 9.53629L1.21479 17.8362C0.916646 18.0723 0.482411 18.0485 0.211854 17.7698C-0.0765161 17.4725 -0.0697135 16.9976 0.227479 16.7092L8.17186 8.99722L0.175721 1.23251C-0.0692961 0.94158 -0.0586857 0.50644 0.211854 0.227618Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight2);
export default __webpack_public_path__ + "static/media/chevron-right-2.db161adde55867bc069987bec42bf900.svg";
export { ForwardRef as ReactComponent };